import React, { Component } from 'react';
import moment from 'moment-timezone';
import {
  View,
  Text,
  Animated,
  StyleSheet,
  Dimensions,
  PanResponder,
  TouchableOpacity,
} from 'react-native';
import { translate } from 'react-i18next';
import { Icon, Avatar, UserDataConsumer } from 'fitbeat.react-native-components';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';

class NotificationCard extends Component {
  constructor(props) {
    super(props);
    const { notification, setScrollEnabled, onDismissNotification } = props;

    this.translateX = new Animated.Value(0);
    this.translateX.addListener(({ value }) => this._value = value);
    this._panResponder = PanResponder.create({
      onStartShouldSetPanResponder: () => false,
      onStartShouldSetPanResponderCapture: () => false,

      // Only enable swipe is its moved more than -1.5 (Left)
      onMoveShouldSetPanResponder: (evt, { dx }) => dx < -1.5,
      onMoveShouldSetPanResponderCapture: () => false,

      onPanResponderMove: (evt, { dx }) => {
        const animatedValue = this.translateX._offset + dx;
        if (animatedValue < 0) { // Moving to left
          setScrollEnabled(false);
          this.translateX.setValue(animatedValue);
        } else {
          setScrollEnabled(true);
        }
      },

      onPanResponderRelease: (e, { vx, dx }) => {
        const screenWidth = Dimensions.get('window').width;

        // Velocity higher than 0.5 or 60% of screen width and moving left
        if ((Math.abs(vx) >= 0.5 || Math.abs(dx) >= 0.6 * screenWidth) && dx < 0) {
          Animated.timing(this.translateX, {
            toValue: -screenWidth,
            duration: 200,
          }).start(async () => onDismissNotification(notification));
        } else {
          Animated.spring(this.translateX, {
            toValue: 0,
            bounciness: 10,
          }).start();
          setScrollEnabled(true);
        }
      },

      onPanResponderTerminate: () => {
        Animated.spring(this.translateX, {
          toValue: 0,
          bounciness: 10,
        }).start();
        setScrollEnabled(true);
      },
    });
  }

  getAvatarIdToLoad = () => {
    const { notification, userProfile } = this.props;
    const { data } = notification;
    let avatarId = userProfile.uid;

    if (data.from) {
      avatarId = data.from;
    }

    return avatarId;
  };

  render() {
    const { notification, gymTimezone, handleNotification } = this.props;

    return (
      <Animated.View
        key={notification.id}
        style={[
          styles.notificationContainer,
          {
            borderLeftColor: severityColors[notification.severity],
          },
          { transform: [{ translateX: this.translateX }] },
        ]}
        {...this._panResponder.panHandlers}
      >
        <TouchableOpacity
          style={styles.innerContainer}
          onPress={() => handleNotification(notification)}
        >
          <View style={styles.avatarContainer}>
            <Avatar
              iconColor={Theme.GREY}
              avatarId={this.getAvatarIdToLoad()}
            />
          </View>
          <View style={styles.messageContainer}>
            <Text style={[
              styles.notificationTitle,
              { color: severityColors[notification.severity] },
            ]}
            >
              {notification.title}
            </Text>
            <Text
              style={styles.messageText}
            >
              {notification.message}
            </Text>
            <Text
              style={styles.timeText}
            >
              {moment(notification.created).tz(gymTimezone).format('D MMMM YYYY   |   HH:mm')}
            </Text>
          </View>
          <View style={styles.arrowContainer}>
            <Icon
              size={defaultScale(25)}
              color={Theme.GREY_MEDIUM}
              name='ios-arrow-forward-outline'
            />
          </View>
        </TouchableOpacity>
      </Animated.View>
    );
  }
}

const severityColors = {
  Info: Theme.GREEN,
  Warning: Theme.YELLOW,
  Urgent: Theme.RED,
};

const styles = StyleSheet.create({
  notificationContainer: {
    margin: defaultScale(10),
    padding: defaultScale(10),
    borderRadius: 3,
    marginBottom: defaultScale(10),
    borderLeftWidth: defaultScale(5),
    flexDirection: 'row',
    marginHorizontal: defaultScale(15),
    borderTopLeftRadius: defaultScale(5),
    alignItems: 'flex-start',
    borderBottomLeftRadius: defaultScale(5),
    backgroundColor: Theme.WHITE,
  },
  notificationTitle: {
    ...Theme.textStyle.bodyCopyMed,
  },
  innerContainer: {
    flex: 1,
    flexDirection: 'row',
  },
  avatarContainer: {
    flex: 0.1,
    flexBasis: 0,
    paddingRight: defaultScale(10),
  },
  messageContainer: {
    flex: 0.85,
    flexBasis: 0,
    paddingRight: defaultScale(10),
  },
  arrowContainer: {
    flex: 0.05,
    flexBasis: 0,
    alignItems: 'flex-end',
  },
  messageText: {
    ...Theme.textStyle.bodyCopyReg,
    flexWrap: 'wrap',
    paddingVertical: defaultScale(10),
    color: Theme.GREY_DARK,
  },
  timeText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_MEDIUM,
  },
});

NotificationCard = UserDataConsumer(NotificationCard);
export default translate(['home'], { wait: true })(NotificationCard);
